import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Deals from "@/pages/Deals";
import Sihtarica from "@/pages/Sihtarica";
import Rekapitulacija from "@/pages/Rekapitulacija";
import Workers from "@/pages/Workers";
import Deadlines from "@/pages/Deadlines";
import Troskovi from "@/pages/Troskovi";
import Invoices from "@/pages/Invoices";
import Pos from "@/pages/Pos";
import Pdv from "@/pages/Pdv";
import Porijeklo from "@/pages/Porijeklo";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/kupci" element={<Protected><Deals /></Protected>} />
      <Route path="/sihtarica" element={<Protected><Sihtarica /></Protected>} />
      <Route path="/rekapitulacija" element={<Protected><Rekapitulacija /></Protected>} />
      <Route path="/radnici" element={<Protected><Workers /></Protected>} />
      <Route path="/rokovi" element={<Protected><Deadlines /></Protected>} />
      <Route path="/fakture" element={<Protected><Invoices /></Protected>} />
      <Route path="/pos" element={<Protected><Pos /></Protected>} />
      <Route path="/troskovi" element={<Protected><Troskovi /></Protected>} />
      <Route path="/pdv" element={<Protected><Pdv /></Protected>} />
      <Route path="/porijeklo" element={<Protected><Porijeklo /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
